import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateStructuredDataAvailability } from '../../helpers/structuredData'

/**
 * Component that monitors availability state and updates structured data availability accordingly.
 * This ensures that the JSON-LD structured data matches the UI state after frontend availability fetch.
 */
class StructuredDataAvailabilityUpdater extends Component {
  componentDidUpdate(prevProps) {
    const { partNumber, isAvailable, requestDone, errorDetail } = this.props

    // Update when:
    // 1. Availability request completes with new data, OR
    // 2. Part number changes (variant selection), OR
    // 3. Availability status changes
    const wasRequestPending = !prevProps.requestDone
    const hasNoError = !errorDetail
    const partNumberChanged = partNumber !== prevProps.partNumber
    const availabilityChanged = isAvailable !== prevProps.isAvailable

    const shouldUpdate =
      partNumber &&
      hasNoError &&
      ((wasRequestPending && requestDone) || // Initial load completion
      partNumberChanged || // Variant change
        availabilityChanged) // Availability status change

    if (shouldUpdate) {
      updateStructuredDataAvailability(partNumber, isAvailable)
    }
  }

  render() {
    return null // This component only handles side effects, no UI
  }
}

StructuredDataAvailabilityUpdater.propTypes = {
  partNumber: PropTypes.string.isRequired,
  isAvailable: PropTypes.bool.isRequired,
  requestDone: PropTypes.bool.isRequired,
  errorDetail: PropTypes.string
}

const mapStateToProps = (state, ownProps) => {
  const { partNumber } = ownProps
  const { availability = {} } = state
  const { data = {}, meta = {} } = availability
  const { requestDone = false, errorDetail = '' } = meta
  const { quantityAvailable = 0 } = data[partNumber] || {}

  const isAvailable = errorDetail ? true : quantityAvailable > 0

  return {
    isAvailable,
    requestDone,
    errorDetail
  }
}

export default connect(mapStateToProps)(StructuredDataAvailabilityUpdater)
export { StructuredDataAvailabilityUpdater }
